// The result component displays the score of the number grid, the score is passed down through props.

import React, { Component } from 'react';
import './result.css';
import { Link } from "react-router-dom";

class Result extends Component {

    render() {

        return (
            <div id="result">
                <div id="score">
                    <h3>Total: {this.props.total}</h3>
                    {this.props.total === 0
                    ? <p>90s per correct answer</p>
                    : <p>{(90 / this.props.total).toFixed(2)}s per correct answer</p>
                }
                    <div id="tryAgain">
                    <Link id="tryAgainButton" to="/screen/" onClick={this.props.reset}><span>Try Again</span></Link>
                </div>
                </div>
            </div>
        )
    }
}

export default Result;